module.exports = __webpack_public_path__ + "static/media/00_tearsofhair.b6bd7176.jpg";